
import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({

    ctnLoader: {
        height: window.innerHeight,
        position: 'fixed',
        top: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#797979b3', // 'rgba(0, 0, 0, 0.7)',
        zIndex: 6,
        minHeight: '100vh',
    },
    ctnSpinner: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        padding: '15px',
        borderRadius: '5px',
        minWidth: '225px',
    },
    loader: {
        border: '6px solid #f3f3f3',
        borderRadius: '50%',
        borderTop: '6px solid #3498db',
        width: '30px',
        height: '30px',
        animation: `$spin 2s linear infinite`,
        float: 'left',
        marginRight: '13px',
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    },
}));